/* This file is for styleguidist */

import Caret from './components/Caret';
import Check from './components/Check';
import Search from './components/Search';
import Close from './components/Close';
import ChevronLeft from './components/Chevron/ChevronLeft';
import ChevronRight from './components/Chevron/ChevronRight';
import ChevronDown from './components/Chevron/ChevronDown';
import Heart from './components/wishList/Heart/Heart';
import HeartFilled from './components/wishList/Heart/HeartFilled';
import Delivery24h from './components/Delivery24h';
import DeliveryFree from './components/DeliveryFree';
import DeliveryPayment from './components/DeliveryPayment';
import Pro from './components/Pro';
import Manomano from './components/Manomano';
import List from './components/wishList/List/List';
import ListFilled from './components/wishList/List/ListFilled';
import Star from './components/Star/Star';
import StarOutline from './components/Star/StarOutline';
import StarHalf from './components/Star/StarHalf';
import OpenInNewTab from './components/OpenInNewTab';

export default {
    Caret,
    Check,
    Search,
    Close,
    ChevronLeft,
    ChevronRight,
    ChevronDown,
    Heart,
    HeartFilled,
    List,
    ListFilled,
    Star,
    StarOutline,
    StarHalf,
    Delivery24h,
    DeliveryFree,
    DeliveryPayment,
    Pro,
    Manomano,
    OpenInNewTab,
};
